import React from 'react';

const ClimateStationList = ({ title, titleTag = 'h2', stations, selectedStationId, getStatus, onSelect, res, className = '' }) => {
    const Title = titleTag;
    return <aside className={`weather-station-list ${className}`.trim()}>
        <Title>{title}</Title>
        {stations.map(station => {
            const status = getStatus(station);
            return <button type="button" key={station.id} className={String(station.id) === String(selectedStationId) ? 'is-selected' : ''} onClick={() => onSelect(station.id)}>
                <i className={`is-${status}`} />
                <span>{station.name}</span>
                <small>{status === 'online' ? res.ONLINE : status === 'offline' ? res.OFFLINE : res.SEM_DADOS}</small>
            </button>;
        })}
    </aside>;
};

export default ClimateStationList;
